import { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const TestimonialCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
  {
    id: 1,
    name: "Ashley Ward",
    role: "Operations Manager",
    image: "/assets/images/WhatsApp_Image_2026-01-22_at_10.24.56-1770149441761.jpeg",
    imageAlt: "Ashley Ward, Operations Manager",
    rating: 5,
    text: "Gert from Pronto maintenance took full responsibility for all maintenance and repair for 30+ restaurants within my portfolio of McDonald's restaurants in Johannesburg and KZN. His professionalism, high work ethic, quality of workmanship and can - do attitude was always admired throughout our interaction. He is definitely the 'go to man' for all maintenance requirements.",
    location: "Johannesburg & KZN"
  }];


  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % testimonials?.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [testimonials?.length]);

  const handlePrevious = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials?.length) % testimonials?.length);
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials?.length);
  };

  const currentTestimonial = testimonials?.[currentIndex];

  return (
    <section className="py-12 md:py-16 lg:py-24 bg-primary text-white relative overflow-hidden">
      <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1497366216548-37526070297c?w=1920')] bg-cover bg-center opacity-5"></div>
      <div className="relative max-w-7xl mx-auto px-4 lg:px-8">
        <div className="text-center mb-8 md:mb-12 lg:mb-16">
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full mb-4">
            <Icon name="Star" size={20} color="var(--color-accent)" />
            <span className="text-sm md:text-base font-semibold">Client Success Stories</span>
          </div>
          
          <h2 className="text-2xl md:text-3xl lg:text-5xl font-bold mb-4">
            Trusted by Hundreds of Satisfied Clients
          </h2>
          
          <p className="text-base md:text-lg lg:text-xl text-gray-200 max-w-3xl mx-auto">
            From emergency repairs to major commercial projects, our clients trust us to deliver excellence every time
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 md:p-8 lg:p-12 border border-white/20 shadow-elevated">
            <div className="flex flex-col md:flex-row items-center gap-6 md:gap-8 mb-6 md:mb-8">
              <div className="flex-shrink-0">
                <div className="w-20 h-20 md:w-24 md:h-24 rounded-full overflow-hidden border-4 border-accent">
                  <Image
                    src={currentTestimonial?.image}
                    alt={currentTestimonial?.imageAlt}
                    className="w-full h-full object-cover" />

                </div>
              </div>

              <div className="flex-1 text-center md:text-left">
                <div className="flex justify-center md:justify-start gap-1 mb-2">
                  {[...Array(currentTestimonial?.rating)]?.map((_, i) =>
                  <Icon key={i} name="Star" size={20} color="var(--color-accent)" className="fill-current" />
                  )}
                </div>

                <h3 className="text-xl md:text-2xl font-bold mb-1">{currentTestimonial?.name}</h3>
                <p className="text-sm md:text-base text-gray-300">{currentTestimonial?.role}</p>
                <div className="flex items-center justify-center md:justify-start gap-2 mt-2 text-sm text-gray-400">
                  <Icon name="MapPin" size={16} />
                  <span>{currentTestimonial?.location}</span>
                </div>
              </div>
            </div>

            <blockquote className="text-base md:text-lg lg:text-xl text-gray-100 leading-relaxed mb-6 md:mb-8 text-center md:text-left">
              "{currentTestimonial?.text}"
            </blockquote>

            <div className="flex items-center justify-between">
              <button
                onClick={handlePrevious}
                className="p-3 bg-white/10 hover:bg-white/20 rounded-full transition-all duration-300"
                aria-label="Previous testimonial">

                <Icon name="ChevronLeft" size={24} />
              </button>

              <div className="flex gap-2">
                {testimonials?.map((_, index) =>
                <button
                  key={index}
                  onClick={() => setCurrentIndex(index)}
                  className={`w-2 h-2 rounded-full transition-all duration-300 ${
                  index === currentIndex ? 'bg-accent w-8' : 'bg-white/30'}`
                  }
                  aria-label={`Go to testimonial ${index + 1}`} />

                )}
              </div>

              <button
                onClick={handleNext}
                className="p-3 bg-white/10 hover:bg-white/20 rounded-full transition-all duration-300"
                aria-label="Next testimonial">

                <Icon name="ChevronRight" size={24} />
              </button>
            </div>
          </div>
        </div>

        <div className="mt-12 md:mt-16 text-center">
          <a href="/client-success-stories" className="inline-flex items-center gap-2 text-accent hover:text-accent/80 font-semibold text-base md:text-lg transition-colors">
            <span>Read More Success Stories</span>
            <Icon name="ArrowRight" size={20} />
          </a>
        </div>
      </div>
    </section>);

};

export default TestimonialCarousel;